module.exports = __webpack_public_path__ + "7340c20cc490f3d036c172e6b49c0763.png";